import axios from 'axios';
import config from 'login/config/index.js';
import Logger from '@sm360/logger-sentry';
import { ConfigsService as GeneralConfigsService, HTTPService } from '@sm360/widget-commons-core-services';
import { LeadSubmissionBuilder, LEAD_TYPES } from '@sm360/widget-commons-leads';
import { AnalyticsService } from '@sm360/widget-commons-general';

import TokenService from 'login/services/TokenService/TokenService.js';
import TAGS from 'login/constants/trackingTags';

class FacebookAuthenticationService {
    constructor() {
        this.accountBasePath = `${config.endpoint.account}/accounts`;

        this.logger = new Logger('FacebookAuthenticationService', GeneralConfigsService.getLoggerContext());

        this.headers = {
            'Content-Type': 'text/plain',
            Accept: 'text/plain',
        };
    }

    authenticate(facebookToken, quote) {
        const tokenTypeParam = 'tokenType=SHORT';
        const organizationIdParam = `organizationId=${GeneralConfigsService.getOrganizationId()}`;
        const organizationUnitIdParam = `organizationUnitId=${GeneralConfigsService.getOrganizationUnitId()}`;
        const url = `${
            this.accountBasePath
        }/authenticate/facebook?${organizationIdParam}&${organizationUnitIdParam}&${tokenTypeParam}`;

        AnalyticsService.gaTrigger(TAGS.LOGIN_WIDGET__FB_LOGIN());

        return axios
            .post(url, facebookToken, {
                headers: this.headers,
            })
            .then((response) => {
                TokenService.setUserToken(response.data);
                TokenService.initRefreshTokenJob();
            })
            .catch((error) => {
                const { response } = error;
                const isAccountMissingError = response.status === 404;
                if (!isAccountMissingError) {
                    return Promise.reject(HTTPService.formatRejectResponse('unknownErrorAuthenticating'), response);
                }
                return this.createAccount(facebookToken, quote)
                    .then(() => this.authenticate(facebookToken))
                    .catch((e) => {
                        this.logger.error('Error while creating facebook account / lead', e);
                    });
            });
    }

    createAccount(facebookToken, quote) {
        const organizationIdParam = `organizationId=${GeneralConfigsService.getOrganizationId()}`;
        const organizationUnitIdParam = `organizationUnitId=${GeneralConfigsService.getOrganizationUnitId()}`;
        const url = `${this.accountBasePath}/facebook?${organizationIdParam}&${organizationUnitIdParam}`;
        return axios
            .post(url, facebookToken, {
                headers: {
                    'Content-Type': 'text/plain',
                },
            })
            .then(({ data: account }) => {
                return new LeadSubmissionBuilder()
                    .addLeadType(LEAD_TYPES.ACCOUNT_CREATION)
                    .addContactInformation(undefined, undefined, undefined, undefined, account.contactId)
                    .addQuote(quote)
                    .submit();
            });
    }
}

export default new FacebookAuthenticationService();
